__turbopack_context__.v({
  "backdrop": "HomeUploadDialog-module__sdNQSa__backdrop",
  "closeButton": "HomeUploadDialog-module__sdNQSa__closeButton",
  "declaration": "HomeUploadDialog-module__sdNQSa__declaration",
  "dialog": "HomeUploadDialog-module__sdNQSa__dialog",
  "error": "HomeUploadDialog-module__sdNQSa__error",
  "fileInput": "HomeUploadDialog-module__sdNQSa__fileInput",
  "handIcon": "HomeUploadDialog-module__sdNQSa__handIcon",
  "header": "HomeUploadDialog-module__sdNQSa__header",
  "notes": "HomeUploadDialog-module__sdNQSa__notes",
  "pickButton": "HomeUploadDialog-module__sdNQSa__pickButton",
  "title": "HomeUploadDialog-module__sdNQSa__title",
  "trigger": "HomeUploadDialog-module__sdNQSa__trigger",
  "uploadPanel": "HomeUploadDialog-module__sdNQSa__uploadPanel",
});
